/**
 * @description
 * Renders two action buttons that allow switching between different sub-views
 * (Dining Attendance and Department Access) in the manage view context.
 * The active button is visually highlighted based on the current `subView`.
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Software Developer
 * @Email: kpozos@ibl.mx
 *
 * @param {Object} props - Component props.
 * @param {string} props.subView - The current selected sub-view key.
 * @param {Function} props.handleBtnDinning - Callback function triggered when the Dining Attendance button is clicked.
  * @param {Function} props.handleBtnSettings - Callback to switch to settings view.
 * @param {Function} props.handleBtnDepartmentPolicies - Callback to switch to department policies view.
 * @param {Function} props.handleBtnTotalMeals - Callback to switch to total meal view.
 *
 * @returns {JSX.Element} A pair of navigation buttons for managing sub-views.
 */
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {SUB_VIEW_MODEL} from "../../Model/Models";
import {useSelector} from "react-redux";
import {permissionObj} from "../../../../../Helpers/permission";

const ManageButtonsHeader = ({
    subView,
    handleBtnDinning,
    handleBtnSettings, 
    handleBtnDepartmentPolicies,
    handleBtnTotalMeals
}) => {
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    return (<>
            {(DEV || permission?.includes(permissionObj?.WEB_FOODIE_ATTENDANCE_READ)) &&
                <ButtonAction
                    id='btn_mbh_dining_attendance'
                    name='dining_attendance'
                    className={SUB_VIEW_MODEL.MANAGE.DINING_ATTENDANCE === subView ? 'btn-outlined-secondary-600-100' : 'btn-outlined-secondary-600-00'}
                    disabled={false}
                    splitName={false}
                    onClick={() => {
                        handleBtnDinning();
                    }}
                />
            }
              {(DEV || permission?.includes(permissionObj?.WEB_FOODIE_MANAGE_SETTINGS_READ)) &&
                <ButtonAction
                    id='btn_mbh_settings'
                    name='settings'
                    className={SUB_VIEW_MODEL.MANAGE.SETTINGS === subView ? 'btn-outlined-secondary-600-100' : 'btn-outlined-secondary-600-00'}
                    disabled={false}
                    splitName={false}
                    onClick={() => {
                        handleBtnSettings();
                    }}
                />
                }
            {(DEV || permission?.includes(permissionObj?.WEB_FOODIE_DEPARTMENT_POLICIES_READ)) &&
                <ButtonAction
                    id='btn_mbh_department_policies'
                    name='department_policies'
                    className={SUB_VIEW_MODEL.MANAGE.DEPARTMENT_POLICIES === subView ? 'btn-outlined-secondary-600-100' : 'btn-outlined-secondary-600-00'}
                    disabled={false}
                    splitName={false}
                    onClick={() => {
                        handleBtnDepartmentPolicies();
                    }}
                />
            }
            {(DEV || permission?.includes(permissionObj?.WEB_TOTAL_MEALS_READ)) &&
                <ButtonAction
                    id='btn_mbh_total_meals'
                    name='total_meals'
                    className={SUB_VIEW_MODEL.MANAGE.TOTAL_MEALS === subView ? 'btn-outlined-secondary-600-100' : 'btn-outlined-secondary-600-00'}
                    disabled={false}
                    splitName={false}
                    onClick={() => {
                        handleBtnTotalMeals();
                    }}
                />
            }
        </>
        )
}

export default ManageButtonsHeader;
